/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'gm-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  version = environment.version;

}
